module.exports = __webpack_public_path__ + "img/document.3a61efc6.png";